module.exports = __webpack_public_path__ + "static/media/l-md13.8865d201.png";